import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxTooltipComponent } from './components/atx-tooltip.component';
import { NzToolTipModule } from 'ng-zorro-antd';

@NgModule({
    imports: [
        CommonModule,
        NzToolTipModule,
    ],
    declarations: [
        AtxTooltipComponent,
    ],
    exports: [
        AtxTooltipComponent,
    ],
})

export class AtxTooltipModule {}
